import { render, staticRenderFns } from "./IconCellRenderer.vue?vue&type=template&id=db868cc2&scoped=true"
import script from "./IconCellRenderer.vue?vue&type=script&lang=js"
export * from "./IconCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db868cc2",
  null
  
)

export default component.exports